import { InsightSummaryRenderer } from 'components/insight-summary-renderer';
import { insightTypeToIcon } from 'helpers/insight';
import React, { useCallback } from 'react';
import { WithContentSlotSidePaddingContainer } from 'ds/components/Layout';
import { Text } from 'ds/components/typography';
import { FeedbackDropdown } from './FeedbackDropdown';
import { IHighlight } from './types';
import {
  HighlightIconWrapper,
  HighlightHeaderTitle,
  HighlightWrapper,
  HighlightBody,
  HighlightFooter,
  HighlightHeaderNew,
  BackButtonLinkText,
  BackButtonContainer,
  ContainerNew,
  HighlightHeaderTitleNew,
} from './styled';
import ArrowIcon from 'assets/svg/left.svg';
import { useLocale } from 'locale';

interface HighlightProps extends IHighlight {
  isTransitioning: boolean;
  resetActiveInsightId: () => void;
}

export const HighlightDesktopNew: React.FunctionComponent<HighlightProps> = (props) => {
  const { isTransitioning, resetActiveInsightId, ...highlight } = props;
  const handleBackButtonClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    resetActiveInsightId();
  }, [ resetActiveInsightId ]);
  const { t } = useLocale();

  return (
    <ContainerNew>
      <HighlightHeaderNew data-auto="desktop-opened-tradeoff-title">
        <BackButtonContainer>
          <a onClick={handleBackButtonClick}>
            <ArrowIcon width={24} height={24}/>
            <BackButtonLinkText data-auto="back-button-text">
              {t('expandedHighlight.back')}
            </BackButtonLinkText>
          </a>
        </BackButtonContainer>
        <HighlightIconWrapper insightType={highlight.type}>
          {insightTypeToIcon[highlight.type]}
        </HighlightIconWrapper>
        <HighlightHeaderTitle insightType={highlight.type}>
          <div style={{ display: 'flex' }}>
            <Text data-auto="desktop-opened-tradeoff-title-text">{t('expandedHighlight.title', { insightType: highlight.type })}</Text>
          </div>

        </HighlightHeaderTitle>
      </HighlightHeaderNew>
      <HighlightWrapper data-auto="desktop-opened-tradeoff">
        <HighlightBody>
          <Text>
            <WithContentSlotSidePaddingContainer>
              <HighlightHeaderTitleNew insightType={highlight.type}>{highlight.previewText}</HighlightHeaderTitleNew>
            </WithContentSlotSidePaddingContainer>
            <InsightSummaryRenderer type={highlight.subType} summary={highlight.text} />
          </Text>
        </HighlightBody>
        <HighlightFooter>
          <WithContentSlotSidePaddingContainer>
            <FeedbackDropdown insightId={highlight.id} />
          </WithContentSlotSidePaddingContainer>
        </HighlightFooter>
      </HighlightWrapper>
    </ContainerNew>
  );
};
